import { CalendarDays, IndianRupee } from 'lucide-react';
import moment from 'moment';
import { Card, CardContent, CardHeader, CardTitle } from 'src/components/ui/Card';
import { Subscription } from 'src/redux/types/_customer.type';
import { formatDate, getTitle, validTill } from 'src/utils';

const ActiveSubscription = ({ plan }: { plan: Subscription }) => {
  return (
    <Card className="surface-card border-border/70 p-3 gap-3">
      <CardHeader className='px-0'>
        <CardTitle className="flex items-center text-base">
          Active subscription
        </CardTitle>
      </CardHeader>
      <CardContent className="space-y-3 px-0">
        <div className="rounded-xl border border-border/70 bg-background/40 p-3">
          <p className="text-lg font-semibold">
            {getTitle(plan?.duration, plan?.member)}
          </p>
          <div>
            <p className="text-sm font-medium">
              {plan?.duration} Month{plan?.duration > 1 ? "s" : ""} subscription
              · Total Members: {plan?.member}
            </p>
          </div>
        </div>
        <div className="grid grid-cols-2 gap-3 text-sm">
          <div className="rounded-xl border border-border/70 bg-background/40 px-4 py-3">
            <p className="text-[11px] tracking-[0.12em] text-muted-foreground uppercase">
              Price
            </p>
            <p className="mt-1 flex items-center font-medium">
              <IndianRupee className="mr-0.5 size-3.5" />
              {plan?.amount}
            </p>
          </div>
          <div className="rounded-xl border border-border/70 bg-background/40 px-4 py-3">
            <p className="text-[11px] tracking-[0.12em] text-muted-foreground uppercase">
              Subscribed on
            </p>
            <p className="mt-1 flex items-center gap-1.5 font-medium">
              <CalendarDays className="size-3.5" />
              {plan?.created_at && moment(plan?.created_at).format("Do MMM YYYY")}
            </p>
          </div>
          <div className="rounded-xl border border-border/70 bg-background/40 px-4 py-3">
            <p className="text-[11px] tracking-[0.12em] text-muted-foreground uppercase">
              Renews On
            </p>
            <p className="mt-1 flex items-center gap-1.5 font-medium">
              <CalendarDays className="size-3.5" />
              {plan?.created_at && validTill(plan?.duration, plan?.created_at)}
            </p>
          </div>
        </div>
      </CardContent>
    </Card>
  );
};

export default ActiveSubscription